<script lang="ts">
    import {storable} from "../storable.ts";
    import {email, fetchOrigin, page} from "../data.ts";
    import {busy} from "../busy.ts";
    import {sleep} from "@shared/Utils.ts";

    const lastSentCode = storable('WOB.lastSentCode', 0)
    let msg = '';

    let submitting = false;

    async function sendCode() {
        submitting = true;
        msg = '';
        if (!email) {
            submitting = false;
            return msg = 'Please enter an email';
        }
        lastSentCode.set(Date.now())

        const result = await fetchOrigin(`/send-code/?${new URLSearchParams({email: $email}).toString()}`);
        const json = await result.json();

        if (json.error) {
            await sleep(1000);
            msg = json.error;
            submitting = false;
            return;
        }

        submitting = false;
        page.set('EnterCode')
    }
</script>

<article style="max-width: 720px; margin: 2rem auto;">
    <h1>Enter your email</h1>
    <p>
        Welcome to the Weekend on the Bay registration website!<br><br>
        To log in, enter your email address below. <br><br>
        The system will send a 6-digit code to your email account.  When prompted, enter that 6-digit code to access the registration system.
    </p>

    {#if msg}
        <div class="alert alert-warning">
            {msg}
        </div>
    {/if}

        <label>
            Email
            <input type="email" name="email" placeholder="you@example.com" required bind:value={$email} on:keydown={(e) => e.key === 'Enter' && sendCode()}/>
            <small>If you have already registered, be sure to use the same email you registered with.</small>
        </label>

        <button use:busy={sendCode} aria-busy={submitting}>Submit</button>
</article>